import { z } from 'zod';
export const phoneNumberSchema = z.object({
    customer_number: z.string().regex(/^\d+$/, "Invalid customer_number format, must consist of only digits."),
});
export const callsForLeadQuerySchema = z.object({
    order_by: z.enum(["start_timestamp", "disposition_status", "total_duration_seconds", "public_disconnection_reason"]).default("start_timestamp"),
    order_type: z.enum(["asc", "desc"]).default("asc"),
    page_id: z.string()
        .regex(/^\d+$/, "page_id must be a number")
        .default("0")
        .transform((v) => parseInt(v, 10))
        .refine((v) => v >= 0, "page_id must be 0 or greater"),
    page_size: z.string()
        .regex(/^\d+$/, "page_size must be a number")
        .default("2000")
        .transform((v) => parseInt(v, 10))
        .refine((v) => v > 0 && v <= 30000, "page_size must be between 1 and 30000"),
});
export const callForHistoryQuerySchema = z.object({
    startDate: z.coerce.date().optional(),
    endDate: z.coerce.date().optional(),
    pageSize: z.coerce.number(),
    pageId: z.coerce.number(),
    orderBy: z.enum(["phone", "timestamp", "disposition", "duration"]),
    orderType: z.enum(["asc", "desc"]),
    minDurationSeconds: z.coerce.number().optional(),
    disposition: z.coerce.string().optional(),
    autoQaYesMin: z.coerce.number().optional(),
    phone: z.string().optional(),
});
